<template>
  <v-container>
    <component :is="getAccessoriComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/accessories/Index'
  import Insert from './../components/magazzino/accessories/Insert'

  export default {
    name: 'MagazzinoAccessori',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getAccessoriComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_ACCESSORI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_ACCESSORI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>